export function useStores() {
  return useNuxtApp().$stores
}
// @ihgroup
export const useUseragent = () => useStores().useragent
export const useAB = () => useStores().ab
export const useConsent = () => useStores().consent
export const usePopups = () => useStores().popups
export const useIDs = () => useNuxtApp().$ids
export const useToggler = () => useStores().toggler
export const useTracking = () => useStores().tracking
// other
export const useBookmarks = () => useStores().bookmarks
export const useConfdata = () => useStores().confdata
export const useFlexTrip = () => useStores().flextrip
export const usePartner = () => useStores().partner
// export const useRecommendations = () => useStores().recommendations
export const useReviews = () => useStores().reviews
export const useSettings = () => useStores().settings
export const useUserSurvey = () => useStores().usersurvey
